export { default } from './EmployeeDetail'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Employee/EmployeeDetail/index.js